import React from 'react';
import styles from './Blog.module.css';

const BlogPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        
        <div className={styles.header}>
          <h1 className={styles.title}>Blog</h1>
        </div>

        <div className={styles.messageBox}>
          <h2 className={styles.messageTitle}>We are working on it</h2>
        </div>

      </div>
    </div>
  );
};

export default BlogPage;